import React from "react";
import { useState, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import moment from "moment-timezone";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { endPoints } from "../../../constant/Environment";

import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { addData, getAllData } from "../../../Utility/API";
import { Button } from "react-bootstrap";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

const Transactions = (props) => {
  const { userId } = props;
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalcount, setTotalCount] = useState(1);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    Usertransactions(1);
  }, []);

  // withdrawl payments get api call
  const Usertransactions = async (page) => {
    let url = `${endPoints.api.transactions}/${userId}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          let data = response.data;
          //   setRows([]);
          setRows(data);
          setTotalCount(data[0]?.totalcount);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    Usertransactions(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    // setPage(1);
    // Usertransactions(1);
  };

  useEffect(() => {
    setPage(1);
    Usertransactions(1);
  }, [rowsPerPage]);

  const hideTransInfo = () => {
    // let url1 = endPoints.api.WITHDRAW_COIN;
    // let data = {};
    // setIsLoading(true);
    // addData(url1, data)
    //   .then((response) => {
    //     setIsLoading(false);
    //     if (response.data.status === "success") {
    //       SuccesToast("Coins Deposit Succesfully");
    //     } else {
    //       ErrorToast(response?.data.message);
    //     }
    //   })
    //   .catch((err) => {
    //     setIsLoading(false);
    //     console.log(err);
    //   });
  };

  const exportCsv = () => {
    console.log("c--");
    setIsLoading(true);
    // usertransaction/3402/0/1000/download/csv
    fetch(
      `${
        endPoints.apiBaseUrl + `usertransaction/${userId}/0/1000/download/csv`
      }`,
      {
        method: "GET",
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(function (response) {
      setIsLoading(false);
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = "TransactionReport.csv";
        link.click();
      });
    });
  };

  return (
    <div className="custom-table-data">
      <div style={{ display: "flex" }}>
        <h4 className="dark-gray f-bold mb-4">Transactions</h4>
        {/* <Button className="exportbtn" onClick={() => exportCsv()}>
          <img src="/images/icons/csv.png" />
        </Button> */}
      </div>

      <TableContainer component={Paper}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ width: "30%" }}>
                Date
              </TableCell>
              <TableCell align="center">Trans No.</TableCell>
              <TableCell align="center" style={{ width: "30%" }}>
                Refer User Id{" "}
              </TableCell>
              <TableCell align="center">Description </TableCell>
              <TableCell align="center">Game</TableCell>
              <TableCell align="center">Method </TableCell>
              <TableCell align="center">Amount </TableCell>
              <TableCell align="center">Status </TableCell>
              <TableCell align="center">Actoins </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 &&
              rows.map((row) => (
                <TableRow
                  key={row.id_transaction}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                >
                  <TableCell align="center">
                    {/* {moment(row.insertion_time).format("MM/DD/YYYY")} */}
                    {row?.insertion_time?.split("T")[0]}
                  </TableCell>
                  <TableCell align="center">{row.id_transaction}</TableCell>
                  <TableCell align="center">{row.referred_user}</TableCell>

                  <TableCell align="center">{row.description}</TableCell>
                  <TableCell align="center">{row?.bet_id}</TableCell>
                  <TableCell align="center">{row.wallet_type}</TableCell>
                  <TableCell align="center">{row.amount}</TableCell>
                  <TableCell align="center">{row.transaction_status}</TableCell>
                  <TableCell align="center" style={{ width: "100%" }}>
                    <Button
                      onClick={() => {
                        hideTransInfo();
                      }}
                      variant="primary"
                      style={{ marginBottom: "5px" }}
                    >
                      Hide Trans
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
          {rows.length > 0 && (
            <TableFooter>
              <TableRow>
                <TableCell colSpan={12} sx={{ textAlign: "left" }}>
                  <TablePagination
                    className="hide-rows-per-page-options"
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={12}
                    count={rowsPerPage === -1 ? rows.length : totalcount}
                    rowsPerPage={rowsPerPage}
                    page={page - 1}
                    SelectProps={{
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableCell>
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </div>
  );
};

export default Transactions;
